import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import routing_45global from "/opt/buildhome/repo/app/middleware/routing.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  routing_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "video-details": () => import("/opt/buildhome/repo/app/middleware/videoDetails.ts"),
  "sidebase-auth": () => import("/opt/buildhome/repo/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}